// extracted by mini-css-extract-plugin
export default {"tabPanel":"SettingPage_tabPanel__ZcaU-"};